import { render, staticRenderFns } from "./AdditionalInformationConsolidated.vue?vue&type=template&id=c9153cfc&"
import script from "./AdditionalInformationConsolidated.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationConsolidated.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationConsolidated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports